// test1686
(1686 && 0);
